import { render } from "./quiz.vue?vue&type=template&id=3d90dbf6&scoped=true"
import script from "./quiz.vue?vue&type=script&lang=js"
export * from "./quiz.vue?vue&type=script&lang=js"

import "./quiz.vue?vue&type=style&index=0&id=3d90dbf6&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/lify-blends-recommender/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d90dbf6"]])

export default __exports__